var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPyth = function SvgPyth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    style: {
      fill: "#e6dafe"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.4 228.5c0 20.7-16.7 37.5-37.4 37.5v37.5c41.3 0 74.7-33.5 74.7-74.9s-33.5-74.9-74.7-74.9c-13.6 0-26.4 3.6-37.4 10-22.3 12.9-37.4 37.2-37.4 64.9v187.3l33.6 33.7 3.8 3.8V228.5c0-20.7 16.7-37.5 37.4-37.5s37.4 16.9 37.4 37.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266 78.7c-27.2 0-52.7 7.3-74.7 20.1-14.1 8.1-26.7 18.5-37.4 30.7-23.2 26.4-37.4 61.1-37.4 99.1V341l37.4 37.5v-150c0-33.3 14.4-63.2 37.4-83.8 10.8-9.7 23.4-17.3 37.4-22.2 11.7-4.2 24.3-6.4 37.4-6.4 61.9 0 112.1 50.3 112.1 112.4S327.9 340.9 266 340.9v37.5c82.5 0 149.4-67.1 149.4-149.8S348.5 78.7 266 78.7z"
  })));
};
export default SvgPyth;